import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';
type ChartStylesReturnProps = {
  VictoryTooltip: {
    padding: number;
  };
  VictoryBar: {
    barWidth: number;
  };
  VictoryStack: {
    height: number;
  };
};
export const useChartStyles = (theme: DefaultTheme): ChartStylesReturnProps => {
  return useMemo(
    () => ({
      VictoryTooltip: {
        padding: parseInt(theme.spacing(1.25))
      },
      VictoryBar: {
        barWidth: parseInt(theme.spacing(7))
      },
      VictoryStack: {
        height: parseInt(theme.spacing(6.25))
      }
    }),
    [theme]
  );
};
